import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Select, InputNumber, Row, Col, Checkbox, Divider, Spin, message } from 'antd';
import ProductTypeSelect from '../../components/select/productType';
import createInvoice from '../../functions/invoice/createInvoice';
import VatMerchantSelect from '../../components/select/vatMerchant';
import BankCodeSelect from '../../components/select/bankCodeSelect';


const { Option } = Select;

const MerchantInvoice = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [invoiceHasVat, setInvoiceHasVat] = useState(false);
    const [companyName, setCompanyName] = useState('');
    const type=Form.useWatch('type',form)
    const companyRegister=Form.useWatch('companyRegister',form)
    const onFinish =async  (values) => {
        console.log('Received values of form: ', values);
        console.log('merchantId',localStorage.getItem('merchantId'))
        console.log('token',localStorage.getItem('merchantToken'))
        const token=localStorage.getItem('merchantToken')
        var payload={
            ...values,
            merchantId:parseInt(localStorage.getItem('merchantId')),
            returnUrl:'https://spay.esukh.mn/merchantInvoice',
            successCallback:'https://apispay.esukh.mn/api/v1/merchant/paymentHandler',
        }
        if(invoiceHasVat)
        {
            payload.vatInfo={
                type:type,
                companyRegister:companyRegister,
                merchantRegister:values.vatRegister
            }
        }
      
        setLoading(true);
        console.log(payload)
        const result=await createInvoice(payload)
        console.log(result)
        if(result){
            message.success('Invoice created successfully')
            window.location.href=result.url
        }
        setLoading(false);
    };
    useEffect(()=>{
        if(type=='B2B' && companyRegister && (companyRegister.length==8 || companyRegister.length==6)){
            setCompanyName('COMNAME')
        }
    },[companyRegister])
    const changeHasVat = (e) => {
        setInvoiceHasVat(e.target.checked);
    }
 
    return (
        <div style={{ maxWidth: '300px', margin: 'auto', padding: '50px' }}>
            <Form
                form={form}
                size='small'
                layout="vertical"
                onFinish={onFinish}
            >
            <Spin spinning={loading}>
                <Row gutter={16}>
                    <Col span={12}>
                            <Form.Item
                                name="amount"
                                label="Amount"
                                rules={[{ required: true, message: 'Please input the amount!' }, { type: 'number', min: 50, max: 300, message: 'Amount must be between 100 and 500' }]}
                            >
                                <InputNumber style={{ width: '100%' }} />
                            </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="phone"
                            label="Phone"
                            rules={[{ required: true, message: 'Please input the phone number!' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                            <Form.Item
                                name="accountNumber"
                                label="accountNumber"
                                rules={[{ required: true, message: 'Please input the accountNumber!' }]}
                            >
                                <InputNumber style={{ width: '100%' }} />
                            </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="bankCode"
                            label="bankCode"
                            rules={[{ required: true, message: 'Please input the bankCode!' }]}
                        >
                            <BankCodeSelect />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item
                        name="description"
                        label="Description"
                        rules={[{ required: true, message: 'Please input the description!' }]}
                    >
                        <Input.TextArea />
                </Form.Item>

                <Form.Item
                        name="productTypeId"
                        label="Product Type"
                        rules={[{ required: true, message: 'Please select the product type!' }]}
                    >
                    <ProductTypeSelect />
                </Form.Item>
                <Checkbox style={{marginTop:10}} checked={invoiceHasVat} onChange={changeHasVat}>
                    VAT info
                </Checkbox>
                        {invoiceHasVat && <div style={{marginTop:10}}>
                            <Divider orientation="left">VAT Information</Divider>
                                <Form.Item
                                        name="type"
                                        label="VAT Type"
                                        rules={[{ required: true, message: 'Please select the VAT type!' }]}
                                    >
                                        <Select defaultValue={null}>
                                            <Option value={null}>сонго</Option>
                                            <Option value="B2C">Хувь хүн</Option>
                                            <Option value="B2B">Байгууллага</Option>
                                        </Select>
                                </Form.Item>
                                {type=='B2B' && <Form.Item
                                        name="companyRegister"
                                        label="VAT Payer register"
                                        rules={[{ required: true, message: 'Please input the VAT payer!' }]}
                                    >
                                        <Input suffix={<span>{companyName}</span>}/>
                                </Form.Item>}
                                <Form.Item
                                        name="vatRegister"
                                        label="VAT creater register"
                                        rules={[{ required: true, message: 'VAT creater register' }]}
                                    >
                                        <VatMerchantSelect />
                                </Form.Item>
                        </div>}
                        <Form.Item>
                                        <Button type="primary" htmlType="submit">
                                            Create Invoice
                                        </Button>
                        </Form.Item>
             </Spin>
          </Form>
        </div>
    );
};

export default MerchantInvoice;